import React, { Component } from 'react';

import HeatmapView from './HeatmapView';
import Monitoring from './Monitoring';
import PublicTransport from './PublicTransport';
import TrafficFlows from './TrafficFlows';

import { CaseMainTitle } from '../../components/newDesign/CaseMainTitle';
import { MainWrapper } from '../../components/newDesign/MainWrapper/MainWrapper';
import { RadioGroup } from '../../components/newDesign/RadioGroup';

const NAME_COMP = {
  'Общественный транспорт': <PublicTransport />,
  Мониторинг: <Monitoring />,
  'Анализ транспортных потоков': <TrafficFlows />,
  'Транспортные потоки': <HeatmapView />,
};

class Transport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      radio: Object.keys(NAME_COMP)[0],
    };
  }

  radioChange = (value) => {
    this.setState({
      radio: value.target.value,
    });
  };

  render() {
    const { subtabs } = this.props;
    return (
      <MainWrapper>
        <CaseMainTitle>Транспорт</CaseMainTitle>
        <RadioGroup
          onChange={this.radioChange}
          value={this.state.radio}
          list={subtabs.map((i) => ({
            key: i.name,
            value: i.name,
          }))}
        />
        {Object.keys(NAME_COMP).map((nav) => {
          if (nav === this.state.radio) return NAME_COMP[nav];
          else return null;
        })}
      </MainWrapper>
    );
  }
}

export default Transport;
